import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, useLocation, Routes, Route } from 'react-router-dom';
import ChatCompletedPage from './components/ChatCompletedPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function AppWithQuery() {
  const query = useQuery();
  const tParam = query.get('t'); // Get the value of the 't' query parameter
  console.log('t:', tParam); // This will log 'abcd'
  return <App sessionId={tParam} />;
}

root.render(
  // <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<AppWithQuery />} />
        <Route path="/:chatId/completed" element={<ChatCompletedPage />} />
      </Routes>
    </Router>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
